// extracted by mini-css-extract-plugin
export var defaultWrapper = "_js-3";
export var downloadButton = "_js-4";
export var fileContainer = "_js-9 _js-7";
export var fileContainerBase = "_js-7";
export var fileContainerFixedHeight = "_js-8 _js-7";
export var fileInfo = "_js-5";
export var fileInfoWidthRestricted = "_js-6";
export var fileType = "_js-1";
export var fileTypeName = "_js-2";
export var image = "_js-0";
export var link = "_js-b";
export var overflowEllipsis = "_js-a";